export default __webpack_public_path__ + "img/80037316df695a91f2db8992f9254594.svg";